module.exports = "##### Blue\n"